module.exports = __webpack_public_path__ + "static/media/Desert_Main.159ccb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desert_Main.jpg
// module id = 346
// module chunks = 0